//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('pickJobGrpBatchesPicker', {
//        templateUrl: 'views/components/views/pickJobGrpBatchesPicker/pickJobGrpBatchesPicker.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['utilityService', 'pickJobGrpBatchesPickerService', 'logisticService', 'pickJobGrpBatchesService', function (utilityService, pickJobGrpBatchesPickerService, logisticService, pickJobGrpBatchesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                bgPickJobGroupBatchesPicker: {
//                    selected: 'JOBS',
//                    buttons: [
//                        { id: 'JOBS', label: 'bg_pickjobgrpbatchespicker_jobs', color: 'primary', onClick: function () { vm.model.bgPickJobGroupBatchesPicker.selected = 'JOBS'; } },
//                        { id: 'OTHER', label: 'bg_pickjobgrpbatchespicker_other', color: 'primary', onClick: function () { vm.model.bgPickJobGroupBatchesPicker.selected = 'OTHER'; } },
//                    ]
//                },
//                setting: {},
//                selectListBusinessCompanies: [],
//                selectListStockPlaces: [],
//                itemsListPickers: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await pickJobGrpBatchesPickerService.getPickJobGroupBatchesPicker())[0];
//            }

//            async function loadCompanies() {
//                vm.model.selectListBusinessCompanies = await logisticService.listCompanies();
//            }

//            async function loadStockPlaces() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                vm.model.selectListStockPlaces = await pickJobGrpBatchesService.listStockPlaces({ businessco_no: vm.model.setting.businessco_no });
//            }

//            async function loadPickJobGroupBatchesPickers() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;

//                vm.model.itemsListPickers = await pickJobGrpBatchesPickerService.listPickJobGroupBatchesPickers(vm.model.setting);
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                        vm.model.setting.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                        loadStockPlaces();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadCompanies();
//                loadStockPlaces();
//                loadPickJobGroupBatchesPickers();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
